App.namespace.wrap('views.cabinet.publish_unpublish_venue', ($el) => {
  function sendRequest(url) {
    $.redirectPost(url, {
      _token: $('meta[name=csrf-token]').attr('content'),
    }, 'POST');
  }

  $el.each(function () {
    const url = $(this).attr('data-venue-url');
    const status = $(this).attr('data-venue-status');
    if (status === 'published') {
      return;
    }

    $(this).on('click', () => {
      sendRequest(url);
    });
  });
});
